import React, { useEffect, useState } from 'react';

import { useScrollLock, HorizonLine } from '@repo/common';

import { ReactComponent as NavigationLeftIcon } from '@repo/common/assets/icons/20px/icon_20px_navigation-left.svg';
import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-top.svg';

import { getTopicsWithFaqs } from '../../../api/faq/faq.api';

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className='w-full'>
      <button
        className='w-full px-[18px] py-[26px] flex items-center justify-between text-left gap-3'
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          className={`typo-b16Strong text-text-primary flex-1 min-w-0 ${isOpen ? '' : 'truncate'}`}
        >
          Q. {question}
        </span>
        <div className='flex-shrink-0 transition-transform duration-200'>
          {isOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
        </div>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className='px-[18px] py-6 bg-grayscale-gray02 text-text-secondary typo-b14'>
          {answer}
        </div>
      </div>
      <HorizonLine className='bg-grayscale-gray03' />
    </div>
  );
};

const FaqModal = ({ isOpen, onClose }) => {
  useScrollLock(isOpen);

  const [topics, setTopics] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    const fetchTopics = async () => {
      try {
        const data = await getTopicsWithFaqs();
        setTopics(data);
      } catch (error) {
        console.error('Failed to fetch FAQ topics:', error);
      }
    };
    fetchTopics();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-[9999] bg-grayscale-gray01 tabletH:hidden flex flex-col w-full'>
      {/* Header */}
      <div className='w-full px-4 py-4 flex items-center'>
        <button onClick={onClose}>
          <NavigationLeftIcon />
        </button>
        <span className='flex-1 text-center typo-title1'>FAQ</span>
      </div>

      {/* Content */}
      <div className='min-h-0 flex-1 overflow-y-auto overscroll-contain bg-grayscale-gray01 pb-[calc(env(safe-area-inset-bottom,0px)+24px)]'>
        <div className='w-full px-4'>
          {topics.map((topic) => (
            <div key={topic.id} className='w-full mb-6'>
              {/* 토픽 제목 */}
              <div className='px-[18px] py-4 typo-b18Strong text-text-primary italic'>
                {topic.title}
              </div>

              {/* FAQ 항목 */}
              {topic.faqs.map((faq) => (
                <FaqItem
                  key={faq.id}
                  question={faq.question}
                  answer={faq.answer}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqModal;
